export default "__VITE_ASSET__DPVkpz2h__"